import React, { useContext } from "react";
import { StateContext } from "../state";
import { ProgramHeader } from './library/Header';
import Footer from './library/Footer';
import Paywall from "./Paywall";
import RecipientLoginFlows from './recipientLogins';
import AcceptPaymentFlows from './acceptPayment';
import Polling from './pollingForComplete/index';
import CompletePaymentFlows from './completePayment'
import ValidateUserAndInitializePaywall from './validatePayment';
import PendingTransaction from './PendingTransaction';
import ExceptedPayment from './ExceptedPayment';
import NetworkSelectionAccepted from './NetworkSelectionAccepted';
import BaseViewByConfigKey from './BaseViewByConfigKey';
import PerformHealthCheck from "./performHealthCheck";

import { PAYMENT_STATUSES, TOKEN_TYPES } from "../utils/enums";
import SystemNotifications from "./SystemNotifications";

export const RecipientPortal = () => {
  const [appState] = useContext(StateContext);

  const {
    healthCheckPassedOrNotRequired,
    configuration,
    accounts,
    payment,
    tokens,
    selectedPaymentNetwork,
  } = appState;

  let body = null;
  if (!healthCheckPassedOrNotRequired) {
    body = <PerformHealthCheck />
  } else if(
    !tokens[TOKEN_TYPES.VALIDATE_PAYMENT] ||
    !payment ||
    !configuration.programId ||
    !accounts
  ){
    body = <ValidateUserAndInitializePaywall/>
  }
  else {
    switch(payment.status){
      case PAYMENT_STATUSES.PENDING_ACCEPTANCE:
        if(!selectedPaymentNetwork){
          body = <Paywall/>;
          break;
        }
        else if(!tokens[TOKEN_TYPES.RECIPIENT_LOGIN]){
          body = <RecipientLoginFlows/>
        }
        else {
          body = <AcceptPaymentFlows/>
        }
        break;
      case PAYMENT_STATUSES.SENDING:
      case PAYMENT_STATUSES.READY_TO_SEND:
      case PAYMENT_STATUSES.READY_MANUAL:
        body = <PendingTransaction/>;
        break;
      case PAYMENT_STATUSES.POLLING:
        body = <Polling/>;
        break;
      case PAYMENT_STATUSES.ACCEPTED:
        body = <NetworkSelectionAccepted/>;
        break;
      case PAYMENT_STATUSES.COMPLETE:
        body = <CompletePaymentFlows/>;
        break;
      case PAYMENT_STATUSES.EXPIRED:
      case PAYMENT_STATUSES.CANCELLED:
      case PAYMENT_STATUSES.ARCHIVED:
      case PAYMENT_STATUSES.FAILED:
      case PAYMENT_STATUSES.RETURNED:
      case PAYMENT_STATUSES.REFUNDED:
        body = <ExceptedPayment/>;
        break;
      case PAYMENT_STATUSES.ONHOLD:
        body = <BaseViewByConfigKey configKey="onHold" />;
        break;
      default:
        body = null;
        break;
    }
  }

  // TODO use config header instead of hardcoded jetblue header
  return (
    <>
      {configuration.programId && <SystemNotifications/>}
      <div id="app">
        <div id="accent"/>
        <ProgramHeader />
        <div id="main">
          <div id="content">
            {body}
          </div>
        </div>
        <Footer/>
      </div>
    </>
  );
};

export default RecipientPortal;
